import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicyPage from "@/features/public/pages/privacy-policy";

export const Route = createFileRoute("/(public)/_public/privacy-policy")({
  component: PrivacyPolicyPage,
});
